/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createHook,
	createStore,
	type BoundActions,
	type HookFunction,
	type StoreActionApi,
} from '@atlassian/react-sweet-state';

const ProjectBuilderStore = createStore({
	initialState: {
		isProjectBuilderOpen: false,
	},
	actions: {
		hideProjectBuilder:
			(): (({
				setState,
			}: StoreActionApi<{
				isProjectBuilderOpen: boolean;
			}>) => void) =>
			({ setState }) => {
				setState({
					isProjectBuilderOpen: false,
				});
			},
		showProjectBuilder:
			(): (({
				setState,
			}: StoreActionApi<{
				isProjectBuilderOpen: boolean;
			}>) => void) =>
			({ setState }) => {
				setState({
					isProjectBuilderOpen: true,
				});
			},
	},
	name: 'projectBuilder',
});

export const useProjectBuilder: HookFunction<
	{
		isProjectBuilderOpen: boolean;
	},
	BoundActions<
		{
			isProjectBuilderOpen: boolean;
		},
		{
			hideProjectBuilder: () => ({
				setState,
			}: StoreActionApi<{
				isProjectBuilderOpen: boolean;
			}>) => void;
			showProjectBuilder: () => ({
				setState,
			}: StoreActionApi<{
				isProjectBuilderOpen: boolean;
			}>) => void;
		}
	>,
	void
> = createHook(ProjectBuilderStore);
